import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { Box, Center } from '@chakra-ui/react'
import { Config } from '@!/config/config'
import { Paginate } from '@!/components/Paginate'
import { usePurchaseHistories } from '@!/Hooks'
import { breadcrumbAtom } from '@!/atoms/breadcrumbAtom'
import { BookPurchaseHistoryListTable } from '@!/User/BookPurchaseHistoryList/components'
import { isBlank } from '@!/Util'

const BookPurchaseHistoryList = () => {
  const [purchaseHistories, fetchPurchaseHistories] = usePurchaseHistories()
  const [, setBreadcrumb] = useAtom(breadcrumbAtom)
  const [currentPage, setCurrentPage] = useState(1)
  const [showingHistories, setShowingHistories] = useState([])
  const perPage = Config.perPage

  // next_tokenがある場合に表示される追加のページネーションボタンが押された場合、
  // next_tokenを使用し次の履歴を取得する
  const onPageChange = async (page) => {
    setCurrentPage(page)
    const totalPages = Math.ceil(purchaseHistories.histories.length / perPage)
    if (page > totalPages && purchaseHistories.next_token) {
      await fetchPurchaseHistories(purchaseHistories.next_token)
    }
  }

  useEffect(() => {
    fetchPurchaseHistories()
    setBreadcrumb([{ name: 'マンガBANGブックス', ref: '/' }, { name: 'ストア購入履歴' }])
  }, [])

  useEffect(() => {
    const start = (currentPage - 1) * perPage
    const end = start + perPage
    if (purchaseHistories) {
      setShowingHistories(purchaseHistories.histories.slice(start, end))
    }
  }, [purchaseHistories, currentPage])

  // next_tokenがある場合は次のページネーションボタンを用意
  const totalCount = purchaseHistories ? purchaseHistories.histories.length + (purchaseHistories.next_token ? perPage : 0) : 0

  return (
    <Box pt="24px" pb="47px">
      <BookPurchaseHistoryListTable histories={showingHistories} />
      {!isBlank(purchaseHistories?.histories) && (
        <Center mt="24px">
          <Paginate currentPage={currentPage} totalCount={totalCount} perPage={perPage} onPageChange={onPageChange} />
        </Center>
      )}
    </Box>
  )
}

export default BookPurchaseHistoryList
